/// <amd-module name="DistributedTaskUI/ServiceEndpoints/Editor/Utils/ServiceEndpointExtensions" />

import { AzureEndpointConstants } from "ServiceEndpoints/Client/Constants/ServiceEndpoint";
import { ServiceEndpoint } from "ServiceEndpoints/Client/Contracts/ServiceEndpoint";
import { equals } from "VSS/Core/Util/String";

const scheme = "sc://";
const valueComponentSeparator = "/";

export function getFederationSubject(endpoint: ServiceEndpoint): string {
    const currentSubject = endpoint.authorization.parameters[AzureEndpointConstants.WorkloadIdentityFederationSubject];
    if (!hasFederationSubjectChanged(endpoint)) {
        return currentSubject;
    }

    const { organization, project } = parseSubject(currentSubject);
    return `${scheme}${organization}${valueComponentSeparator}${project}${valueComponentSeparator}${endpoint.name}`;
}

export function hasFederationSubjectChanged(endpoint: ServiceEndpoint) {
    if (!endpoint || endpoint.isShared) {
        return false;
    }

    // There can be no two endpoint with the same name in the same project, so it is enough to check the name.
    // The name here is the actual name of this particular shared connection.

    const currentSubject = endpoint.authorization.parameters[AzureEndpointConstants.WorkloadIdentityFederationSubject];
    if (!currentSubject) {
        return false;
    }

    const { endpointName } = parseSubject(currentSubject);
    return !equals(endpoint.name, endpointName, false);
}

export function getFederationIssuer(endpoint: ServiceEndpoint) {
    return endpoint.authorization.parameters[AzureEndpointConstants.WorkloadIdentityFederationIssuer];
}

function parseSubject(subject: string) {
    let value = subject.substring(scheme.length);
    let values = value.split(valueComponentSeparator);

    return {
        organization: values[0],
        project: values[1],
        endpointName: values[2]
    };
}